import React, { useState } from "react";
import { Typography, Box, Grid, Paper } from "@mui/material";

const fontSxTitle = {
  fontSize: ["1rem", "1rem", "1rem", "1rem", "1.25rem", "1.25rem"],
};

const fontSx = {
  fontSize: ["0.75rem", "0.75rem", "0.75rem", "0.75rem", "1rem", "1rem"],
};

const SuperUserPanel = ({
  orgs = [],
  orglessUsers = -1,
  handleSelectGroup,
  handleUpdateOrg,
}) => {
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);

  const onSelectGroup = (org, group) => {
    if (org === selectedOrg && group === selectedGroup) {
      org = null;
      group = null;
    }
    setSelectedOrg(org);
    setSelectedGroup(group);
    handleSelectGroup(org, group);
  };

  const getSelectedStyle = (org, group) => {
    if (org === selectedOrg && group === selectedGroup) {
      return {
        fontWeight: "bold",
        color: "gold",
      };
    }
    return {};
  };

  return (
    <Paper
      className={
        "flex bg-white rounded-xl border-4 border-transparent transition-opacity duration-1000"
      }
    >
      <Box
        sx={{
          width: "100%",
          px: "1rem",
          py: "1rem",
        }}
      >
        <Grid container spacing={1}>
          {orglessUsers > -1 ? (
            <Grid
              size={12}
              container
              sx={{ py: "1rem" }}
              spacing={0}
              key={`org-orgless`}
            >
              <Grid size={12}>
                <Typography sx={fontSxTitle} className={"text-gray-600"}>
                  Unaffiliated
                </Typography>
              </Grid>

              <Grid size={3}></Grid>
              <Grid size={3}>
                <Typography sx={fontSx} className={"text-gray-300"}>
                  Devices (0)
                </Typography>
              </Grid>

              <Grid size={2}></Grid>
              <Grid
                size={3}
                sx={{
                  cursor: "pointer",
                }}
                onClick={() => onSelectGroup("orgless", "users")}
              >
                <Typography
                  sx={{ ...fontSx, ...getSelectedStyle("orgless", "users") }}
                >
                  Users ({orglessUsers})
                </Typography>
              </Grid>
            </Grid>
          ) : null}

          {orgs.map((orgInfo) => (
            <Grid
              container
              size={12}
              sx={{ py: "1rem" }}
              spacing={0}
              key={`org-${orgInfo.org}`}
            >
              <Grid size={12}>
                <Typography
                  sx={fontSxTitle}
                  className={"text-gray-600"}
                  onClick={() => handleUpdateOrg(orgInfo.org)}
                >
                  {orgInfo.org}
                </Typography>
              </Grid>

              <Grid size={3}></Grid>
              <Grid
                size={3}
                sx={{
                  cursor: "pointer",
                }}
                onClick={() => onSelectGroup(orgInfo.org, "devices")}
              >
                <Typography
                  sx={{
                    ...fontSx,
                    ...getSelectedStyle(orgInfo.org, "devices"),
                  }}
                >
                  Devices ({orgInfo.devices})
                </Typography>
              </Grid>

              <Grid size={2}></Grid>
              <Grid
                size={3}
                sx={{
                  cursor: "pointer",
                }}
                onClick={() => onSelectGroup(orgInfo.org, "users")}
              >
                <Typography
                  sx={{ ...fontSx, ...getSelectedStyle(orgInfo.org, "users") }}
                >
                  Users ({orgInfo.users})
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Paper>
  );
};

export default SuperUserPanel;
